"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "gift_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12v10h18V12"
  })), /*#__PURE__*/React.createElement("path", {
    className: "gift_svg__gift-icon-body",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12v10h18V12",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gift_svg__gift-icon-border",
    fill: "#17181A",
    mask: "url(#gift_svg__a)",
    d: "M3.5 22h-1v1h1v-1zm18 0v1h1v-1h-1zm-19-10v10h2V12h-2zm1 11h18v-2h-18v2zm19-1V12h-2v10h2z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "gift_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.278 12H2.5V7h20v5h-7.778"
  })), /*#__PURE__*/React.createElement("path", {
    className: "gift_svg__gift-icon-body",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.278 12H2.5V7h20v5h-7.778",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gift_svg__gift-icon-border",
    fill: "#17181A",
    mask: "url(#gift_svg__b)",
    d: "M2.5 12h-1v1h1v-1zm0-5V6h-1v1h1zm20 0h1V6h-1v1zm0 5v1h1v-1h-1zm-12.222-1H2.5v2h7.779v-2zM3.5 12V7h-2v5h2zm-1-4h20V6h-20v2zm19-1v5h2V7h-2zm1 4h-7.778v2H22.5v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gift_svg__gift-icon-bow",
    stroke: "#17181A",
    fill: "transparent",
    d: "M14.5 8v14m-4-14v14m1.732-15.171c.093.26.16.486.206.668-1.175.025-2.688-.087-3.963-.483C6.958 6.54 6 5.752 6 4.523c0-.692.195-1.167.465-1.48.272-.313.657-.504 1.114-.562.929-.119 2.11.326 2.916 1.332.95 1.185 1.462 2.253 1.737 3.016zm.536 0c-.093.26-.16.486-.206.668 1.175.025 2.688-.087 3.963-.483C18.042 6.54 19 5.752 19 4.523c0-.692-.195-1.167-.465-1.48-.272-.313-.657-.504-1.114-.562-.928-.119-2.11.326-2.915 1.332-.95 1.185-1.463 2.253-1.738 3.016z"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgGift);
var _default = Memo;
exports["default"] = _default;